import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ALL, ALLOCATED, UNALLOCATED } from "../../consts/routeDetails";
import { palette } from "../../theme/palette";
import { AllRoutes, AllocatedRoutes, UnallocatedRoutes } from "../Icons";
import { View } from "../View";
import { postcodeViewSelector } from "../../reducers/depot/selectors";
import { setPostcodeView } from "../../reducers/depot";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "white",
    "& svg": {
      height: "32px",
      width: "32px",
      cursor: "pointer",
    },
  },
  padding: {
    height: "28px !important",
    width: "28px !important",
    paddingTop: "2px",
    paddingBottom: "2px",
  },
});

export const ArtificialPostcodeViews = memo(() => {
  const view = useSelector(postcodeViewSelector);
  const dispatch = useDispatch();
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <ButtonBase
        onClick={() => {
          dispatch(setPostcodeView(ALLOCATED));
        }}
        disableRipple={true}
      >
        <AllocatedRoutes
          fill={
            view === ALLOCATED ? palette.orange : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setPostcodeView(UNALLOCATED));
        }}
        disableRipple={true}
      >
        <UnallocatedRoutes
          fill={
            view === UNALLOCATED
              ? palette.orange
              : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setPostcodeView(ALL));
        }}
        disableRipple={true}
      >
        <AllRoutes
          className={styles.padding}
          fill={view === ALL ? palette.orange : palette.typography.white.high}
        />
      </ButtonBase>
    </View>
  );
});
